export enum WeatherCancellation {
  ShowersCancel = 'SHOWERS_CANCEL',
  SteadyRainCancel = 'STEADY_RAIN_CANCEL',
  IceSnowCancel = 'ICE_SNOW_CANCEL',
  AllWeather = 'ALL_WEATHER',
} 